import { Helmet } from 'react-helmet-async'
import Section from '../components/common/Section'

export default function ImpressumPage() {
  return (
    <>
      <Helmet>
        <title>Impressum - Gabriele Wiedemann</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Section>
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-serif text-primary mb-8">Impressum</h1>

          <div className="prose prose-neutral max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="mb-4">
                <strong>Gabriele Wiedemann</strong>
                <br />
                Künstlerin
                <br />
                Kaiserstuhl
                <br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">Kontakt</h2>
              <p className="mb-4">
                <strong>E-Mail:</strong> <a href="mailto:info@gwiedemann.de" className="text-primary hover:text-secondary">info@gwiedemann.de</a>
                <br />
                <strong>Telefon:</strong> <a href="tel:+4915123602627" className="text-primary hover:text-secondary">+49 151 23602627</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <p className="mb-4">
                Gabriele Wiedemann
                <br />
                Kaiserstuhl, Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">EU-Streitschlichtung</h2>
              <p className="mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-secondary ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="mb-4">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">Verbraucher­streit­beilegung / Universal­schlichtungs­stelle</h2>
              <p className="mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">Haftungsausschluss</h2>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Haftung für Inhalte</h3>
              <p className="mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                Tätigkeit hinweisen.
              </p>
              <p className="mb-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
                entfernen.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Haftung für Links</h3>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
                der Seiten verantwortlich.
              </p>
              <p className="mb-4">
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Urheberrecht</h3>
              <p className="mb-4">
                Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung
                und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung der jeweiligen Autorin bzw. Erstellerin.
              </p>
              <p className="mb-4">
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
                Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht von der Betreiberin
                erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
                aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
                Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </section>
          </div>
        </div>
      </Section>
    </>
  )
}
